import { usePutHttp } from "../../../../hooks/http/http.hook";
import type { IUser } from "../../../../types/models/user.models.types";

interface IBody {
  name: string;
}

interface IResponse {
  user: IUser;
}

export function useUpdateProfileHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/brand/profile",
  });
}
